export function extractApiError(error, fallbackMessage = 'Something went wrong.') {
  const data = error?.response?.data;

  if (!data) {
    return fallbackMessage;
  }

  if (typeof data.error?.message === 'string') {
    return data.error.message;
  }

  if (typeof data.error === 'string') {
    return data.error;
  }

  if (typeof data.message === 'string') {
    return data.message;
  }

  if (typeof data === 'object') {
    const fieldMessages = Object.entries(data)
      .flatMap(([field, value]) => {
        if (Array.isArray(value)) {
          return value.map((item) => `${field}: ${item}`);
        }
        if (typeof value === 'string') {
          return `${field}: ${value}`;
        }
        return [];
      })
      .filter(Boolean);

    if (fieldMessages.length > 0) {
      return fieldMessages.join(' ');
    }
  }

  return fallbackMessage;
}
